module.exports = __webpack_public_path__ + "static/media/expense.83f02288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/expense.svg
// module id = 2096
// module chunks = 0